import { render } from "./Uslugi.vue?vue&type=template&id=47a46289&scoped=true"
import script from "./Uslugi.vue?vue&type=script&lang=js"
export * from "./Uslugi.vue?vue&type=script&lang=js"

import "./Uslugi.vue?vue&type=style&index=0&id=47a46289&lang=scss&scoped=true"

import exportComponent from "K:\\projects\\advocate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a46289"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator});
